'use strict';

angular.module('contartemx.cuenta.administrar', [
  'contartemx',
  'ui.router',
  'ui.bootstrap'
])
  .controller('AdministrarCuentaCtrl', ($scope, $state, $stateParams, $timeout, apiCall, mostrarNotificacion, ServicioChargebee) => {

    $scope.SeCargo = false;
    $scope.DatosCuenta = null;
    $scope.llamadoPantalla = 1;

    $scope.showMembresia = true;
    $scope.showCapacidad = false;
    $scope.showImportar = false;
    $scope.showPagos = true;
    $scope.showRecompensas = false;
    $scope.showExportar = false;

    $scope.paqueteTimbres = [10,20,50,100,200,500,1000];

    const ContarteAPI = new apiCall($scope);

    const claveContribuyente = $state.is('preferencias.suscripcion') ? $scope.userInfo.ClaveContribuyente : $stateParams.cveContribuyente;

    if (claveContribuyente) {
      ContarteAPI.post('ObtenerPantallaAdministrarCuenta', { CveContribuyente: claveContribuyente }).
        then(data => {
          if (data.Respuesta && !data.EsError) {
            $scope.DatosCuenta = data.Respuesta;
            $scope.SeCargo = true;

            var dias = $scope.DatosCuenta.DiasMembresia, restantes = $scope.DatosCuenta.DiasRestantes;

            if (dias < restantes) dias = restantes;

            if (dias > 0 && restantes > 0) {

              $timeout(() => {

                var rows = [];
                var cols = [];
                var c;

                rows.push({
                  c: [
                    { v: "Días restantes" },
                    { v: restantes }
                  ]
                });

                rows.push({
                  c: [
                    { v: "Días usados" },
                    { v: dias - restantes }
                  ]
                });

                cols =
                  [
                    { id: "t", label: "Días restantes", type: "string" },
                    { id: "s", label: "Días usados", type: "string" }
                  ];

                var chart1 = {};
                chart1.format = {};
                chart1.type = "PieChart";
                chart1.cssStyle = "";

                chart1.data = {
                  "cols": cols,
                  "rows": rows
                };

                var options = {
                  isStacked: true,
                  fill: 20,
                  pieHole: .75,
                  backgroundColor: "#f2f4f4",
                  fontSize: 12,
                  height: "100%",
                  width: "100%",
                  chartArea: { width: "80%", height: "100%" },
                  colors: ['#D6202D', '#4F8BEB'],
                  legend: "none",
                  pieSliceText: "none",
                  enableInteractivity: false,
                  reverseCategories: true,
                  pieSliceTextStyle: {
                    color: 'black'
                  },
                };
                chart1.options = options;
                $scope.DiasRestantes = chart1;

                $scope.tituloDiasRestantes = `${restantes}/${dias}`;
              }, 100);

            };

          }
          else {
            mostrarNotificacion.error(data.Mensaje);
          }
        },
          error => {
            mostrarNotificacion.error(error.Mensaje);
          });
    }

    ContarteAPI.post('ObtenerListaPlan', { tipo: 'contribuyente' })
      .then((data) => {

        if (data.ListaRespuestas) {
          $scope.listaPlanes = data.ListaRespuestas;
          $scope.planSeleccionado = $scope.listaPlanes[0];
        } else {
          mostrarNotificacion.error(data.Mensaje);
        }

      }, error => { mostrarNotificacion.error(error.mensaje) });

    $scope.popoverRenovarMembresia = {
      template: '../../../../../ng-contartemx/app/views/Administracion/Cuentas/RenovarMembresia_popover.html',
      triggers: 'click outsideClick'
    };

    $scope.ComprarMembresia = (plan) => {

      if (plan) {
        ServicioChargebee.abrirCheckoutSuscripcion({
          planId: plan.Id,
          cveContribuyente: claveContribuyente
        });
      }

    };

    $scope.ComprarTimbres = () => {

      if ($scope.cantidadTimbres && $scope.cantidadTimbres) {
        ServicioChargebee.abrirCheckoutTimbres({
          tipo: "CONTRIBUYENTE-TIMBRES",
          clave: claveContribuyente,
          cantidad: $scope.cantidadTimbres
        });
      } else {
        mostrarNotificacion.error("Debes elegir el número de timbres.");
      }

    };

    $scope.portalChargebee = () => {

      ServicioChargebee.abrirPortal();

    };

    $scope.EnviarCorreoMembresia = () => {

      let CveContribuyente = claveContribuyente;

      let data = { subject: "Adquirir Timbres/Membresía", CveContribuyente };
      ContarteAPI.post('EnviarCorreoTimbresMembresias', data)
        .then((res) => {
          if (res.EsError) {
            mostrarNotificacion.error("Hubo un error al mandar la petición");
          } else {
            mostrarNotificacion.info("Se ha enviado tu petición.");
          }
        }, (error) => {
          mostrarNotificacion.error("Hubo un error al mandar la petición.");
        });
    };

  });
